import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {UserblockService} from './userblock.service';
import {SettingsService} from '../../../core/settings/settings.service';

@Component({
    selector: 'app-userblock',
    templateUrl: './userblock.component.html',
    styleUrls: ['./userblock.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class UserblockComponent implements OnInit {

  constructor(public userblockService: UserblockService,
              public settings: SettingsService) {
  }

  ngOnInit() {
    this.userblockService.setCurrentUser();
  }

  userBlockIsVisible() {
    return this.userblockService.getVisibility();
  }

}
